import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Sparkles, X } from "lucide-react";

export default function ServiceDetailModal({ service, open, onOpenChange }) {
  if (!service) return null;

  const handleBook = () => {
    onOpenChange(false);
    setTimeout(() => {
      const el = document.getElementById("booking");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 200);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="service-modal"
        className="max-w-4xl w-[calc(100%-2rem)] p-0 overflow-hidden bg-[#0A1428] border border-[#D4AF37]/30 text-cream rounded-2xl max-h-[92vh] overflow-y-auto"
      >
        <DialogTitle className="sr-only">{service.title}</DialogTitle>
        <DialogDescription className="sr-only">{service.desc}</DialogDescription>

        <div className="grid md:grid-cols-2">
          {/* Image */}
          <div className="relative h-64 md:h-full min-h-[280px] overflow-hidden">
            <img
              src={service.image}
              alt={service.title}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t md:bg-gradient-to-r from-[#050B14] via-[#050B14]/40 to-transparent" />
            <div className="absolute top-5 left-5 glass px-4 py-2 rounded-full">
              <span className="font-devanagari text-[13px] text-gold">
                {service.titleHi}
              </span>
            </div>
          </div>

          {/* Content */}
          <div className="p-8 sm:p-10">
            <div className="text-[11px] tracking-[0.4em] uppercase text-gold-light">
              Service · सेवा
            </div>
            <h3
              data-testid="service-modal-title"
              className="font-display text-3xl sm:text-4xl mt-3 text-cream leading-tight"
            >
              {service.title}
            </h3>

            <p className="mt-5 text-cream-muted leading-relaxed text-[14px]">
              {service.long}
            </p>

            <div className="mt-7">
              <div className="text-[11px] tracking-[0.28em] uppercase text-gold">
                Key Benefits
              </div>
              <ul className="mt-4 space-y-3">
                {service.benefits.map((b, i) => (
                  <li
                    key={i}
                    className="flex gap-3 text-[13.5px] text-cream leading-relaxed"
                  >
                    <CheckCircle2
                      className="w-4 h-4 mt-0.5 shrink-0 text-gold"
                      strokeWidth={1.6}
                    />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <Button
                data-testid="service-modal-book-btn"
                onClick={handleBook}
                className="rounded-full h-11 px-7 bg-[#D4AF37] text-[#050B14] hover:bg-[#F3E5AB] font-semibold text-[11.5px] tracking-[0.24em] uppercase gold-glow"
              >
                <Sparkles className="w-4 h-4 mr-2" />
                Book Consultation
              </Button>
              <Button
                data-testid="service-modal-close-btn"
                variant="outline"
                onClick={() => onOpenChange(false)}
                className="rounded-full h-11 px-6 gold-border bg-transparent text-gold hover:bg-[#D4AF37]/10 text-[11.5px] tracking-[0.24em] uppercase"
              >
                <X className="w-4 h-4 mr-2" />
                Close
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
